export default __webpack_public_path__ + "static/media/amy.c456849b.png";